import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
  bedBathsDisplayString,
} from 'common/formatters';

class SrApartmentUnitRow extends Component {
  static propTypes = {
    apartmentUnit: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
    this._unmounting = false;
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  _onListingClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      clicked: !this.state.clicked,
    });
  }

  render() {
    const { apartmentUnit } = this.props;
    const { clicked } = this.state;

    return (
      <tbody>
        <tr
          className={classnames(
            'apartmentUnitInfoRow',
            apartmentUnit.photos[0] && 'pointer',
          )}
          key={apartmentUnit.smartApartmentUnitId}
          onClick={apartmentUnit.photos[0] && this._onListingClick}
        >
          <td>
            <span className={classnames(
              'bedBaths',
              apartmentUnit.photos[0] && 'hasFloorplan',
            )}
            >
              {bedBathsDisplayString(apartmentUnit)}
              {apartmentUnit.photos[0] && (
                <span className='floorplan' />
              )}
            </span>
          </td>
          <td className='bold right'>{apartmentUnit.squareFeet}</td>
        </tr>
        <tr
          className={classnames(
            'apartmentUnitPhotoRow',
            clicked && 'clicked',
          )}
          key={apartmentUnit.apartmentUnit}
          onClick={apartmentUnit.photos[0] && this._onListingClick}
        >
          <td colSpan='3'>
            <div
              className='apartmentUnitPhotoContainer'
              style={{
                backgroundImage: `url("${apartmentUnit.photos[0]}")`,
                backgroundSize: 'contain',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                height: '80vh',
                maxHeight: '400px',
              }}
            />
          </td>
        </tr>
      </tbody>
    );
  }
}

SrApartmentUnitRow.displayName = 'SrApartmentUnitRow';

export default SrApartmentUnitRow;
